export default __webpack_public_path__ + "imgs/9a8e87863338c9706a174308d8003534.png";